<script lang="ts" setup>
import type { PropType } from 'vue'
import type { Maybe, Sds_PageList } from '~/schema/types/generated'

const { brands, displayRow } = defineProps({
    brands: {
        type: Array as PropType<Maybe<Pick<Sds_PageList, 'name' | 'priority' | 'isActive' | 'imgUrl' | 'title'>[]>>,
        required: true,
    },
    displayRow: {
        type: Boolean,
        default: false,
    },
    catTitle: {
        type: String,
        required: true,
    },
    subCatTitle: {
        type: String,
        required: true,
    },
})

const { sendMenuEvent } = useSendEvent()
</script>

<template>
    <div
        class="gap-2"
        :class="displayRow ? 'flex' : 'grid grid-cols-2'"
    >
        <template
            v-for="brand in brands"
            :key="brand.name"
        >
            <a
                :href="`/lp/strefa-dobrych-sprzetow/${brand.name}`"
                :class="{
                    'flex-1': displayRow,
                }"
                @click="
                    sendMenuEvent(
                        `${catTitle} > ${subCatTitle} > ${brand.name}`,
                        `/lp/strefa-dobrych-sprzetow/${brand.name}`,
                    )
                "
            >
                <PlusBlogLpMoleculeMenuCloseItemDesktop>
                    <PlusBlogLpAtomCard class="flex h-12 items-center justify-center p-2">
                        <img
                            :src="brand?.imgUrl ?? ''"
                            :alt="brand?.name ?? ''"
                            class="size-auto max-h-[28px]"
                        />
                    </PlusBlogLpAtomCard>
                </PlusBlogLpMoleculeMenuCloseItemDesktop>
            </a>
        </template>
    </div>
</template>
